
// nav / 内容区已注释，暂时关闭相关依赖
// import atlas from "@/components/atlas.vue";
// import { eventUploadMixin } from '@/plugins/hwtag/events';
export default {
  // mixins: [eventUploadMixin],
  data() {
    return {
      // navId: 0,
      // tab: 1,
      // navActive: "contestInfo",
      scrollTop: 0,// 屏幕滚动
      // currentPage: 1,
      // source: "",
      bannerH: 0,
      headerH: 0,
      // timeDate: new Date().getTime(),
      // isShowOne: new Date().getTime() > 1742918400,
      // isShowTwo: new Date().getTime() > 1742961540,
      // isShowThree: new Date().getTime() > 1742961600,
      WindowWidth: "",
      sidebar: "es",
      imgUrl: "https://resource.xp-pen.com/img/Contest/JerseyChallengePT/",
      sliderList: [
        {
          type: "es",
          lang: "Español",
          text: "Español"
        },
        {
          type: "pt",
          lang: "Português",
          text: "Português"
        },
      ],
      // meritWinnerList: [
      //   {
      //     winnerName: "@rajathk",
      //     winnerHref: "https://community.xp-pen.com/gallery/30133",
      //   },
      //   {
      //     winnerName: "@ye0nyh",
      //     winnerHref: "https://community.xp-pen.com/gallery/29997",
      //   },
      //   {
      //     winnerName: "@bakamaru",
      //     winnerHref: "https://community.xp-pen.com/gallery/29963",
      //   },
      //   {
      //     winnerName: "@XFANSzhszcgh3",
      //     winnerHref: "https://community.xp-pen.com/gallery/29738",
      //   },
      //   {
      //     winnerName: "@XFANSzmb0tsoi",
      //     winnerHref: "https://community.xp-pen.com/gallery/29813",
      //   },
      //   {
      //     winnerName: "@sandeep_avalokitharts",
      //     winnerHref: "https://www.instagram.com/p/DCsi2ziCW2x/",
      //   },
      // ],
      // currentStep: 0,
      // progressWidth: 0,
      // timelineConfig: {
      //   es: [
      //     {
      //       startTime: "2026-06-11 14:00:00",
      //       endTime: "2026-06-20 14:00:00",
      //     },
      //     {
      //       startTime: "2026-06-20 14:00:00",
      //       endTime: "2026-06-30 14:00:00",
      //     },
      //     {
      //       startTime: "2026-06-30 14:00:00",
      //       endTime: "2026-08-11 14:00:00",
      //     },
      //   ],
      //   pt: [
      //     {
      //       startTime: "2026-06-11 14:00:00",
      //       endTime: "2026-06-20 14:00:00",
      //     },
      //     {
      //       startTime: "2026-06-20 14:00:00",
      //       endTime: "2026-06-30 14:00:00",
      //     },
      //     {
      //       startTime: "2026-06-30 14:00:00",
      //       endTime: "2026-08-11 14:00:00",
      //     },
      //   ]
      // },
    };
  },
  head() {
    return {// 优化seo：动态设置title，keywords 和 description
      title: "El Gran Reto Camisetero · Fenix × Copa 2026",
      meta: [
        {
          name: "keywords",
          content: "El Gran Reto Camisetero · Fenix × Copa 2026",
        },
        {
          hid: "description",
          name: "names",
          content:
            "El color es el idioma más sincero de los fanáticos. Nos enamoramos de un equipo muchas veces a través de una camiseta: ese verde que te detuvo el corazón, ese azul que te acompañó en noches de llorar y saltar, ese amarillo que nunca dejó de brillar en tu memoria.",
        },
      ],
    };
  },
  // components: { atlas },
  computed: {},
  watch: {
    sidebar: {
      handler: function (val) {
        this.$i18n.locale = val;
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.WindowWidth = window.innerWidth;
    // this.parametricWork();
    window.addEventListener("scroll", this.handleScroll, true);

    if (this.$route.query.lang) {// 设置默认语言为 es
      const lang = this.$route.query.lang;
      this.changeLanguage(lang);
    } else {
      this.changeLanguage("es");
    }
    // this.calculateProgress();
    // setInterval(this.calculateProgress, 1000);// 添加定时器，每秒更新进度
    this.initDimensions();// 等待所有图片加载完成后再计算尺寸
    window.addEventListener("load", this.initDimensions);
  },
  beforeDestroy() {
    window.removeEventListener("load", this.initDimensions);
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    initDimensions() {// 初始化页面尺寸
      this.$nextTick(() => {
        this.bannerH = this.$refs.bannerHeight.offsetHeight;
        this.headerH = document.getElementsByTagName("header")[0].offsetHeight;
      });
    },
    // calculateProgress() {// 优化进度条计算方法
    //   const now = new Date().getTime();
    //   const currentConfig = this.timelineConfig[this.sidebar || 'es'];// 根据当前语言获取对应的时间配置
    //   const firstStart = new Date(currentConfig[0].startTime).getTime();
    //   const lastEnd = new Date(currentConfig[currentConfig.length - 1].endTime).getTime();
    //
    //
    //   if (now < firstStart) {// 时间线之前
    //     this.currentStep = 0;
    //     this.progressWidth = 0;
    //     return;
    //   }
    //
    //
    //   if (now > lastEnd) {// 时间线之后
    //     this.currentStep = currentConfig.length;
    //     this.progressWidth = 100;
    //     return;
    //   }
    //
    //
    //   for (let i = 0; i < currentConfig.length; i++) {// 计算当前进度
    //     const start = new Date(currentConfig[i].startTime).getTime();
    //     const end = new Date(currentConfig[i].endTime).getTime();
    //
    //     if (now >= start && now <= end) {
    //       this.currentStep = i;
    //
    //       const stageProgress = (now - start) / (end - start);// 计算当前阶段内的动态进度
    //       switch (i) {
    //         case 0:
    //
    //           this.progressWidth = stageProgress * 14;// 第一阶段：0-14%
    //           break;
    //         case 1:
    //
    //           this.progressWidth = 14 + (stageProgress * 40);// 第二阶段：14-54%
    //           break;
    //         case 2:
    //
    //           this.progressWidth = 54 + (stageProgress * 36);// 第三阶段：54-90%
    //           break;
    //       }
    //       break;
    //     } else if (now > end && i < currentConfig.length - 1) {// 如果当前时间超过了这个阶段，设置为下一阶段的起始值
    //       this.currentStep = i + 1;
    //       this.progressWidth = i === 0 ? 14 : i === 1 ? 54 : 90;
    //     }
    //   }
    // },
    //
    // async parametricWork(type, page = 1) {// 作品方法
    //   let res = await this.$global.parametricWork({
    //     activityId: 64,
    //     page: page,
    //     award: 0,
    //   });// res.code = '200' ? (this.source = res.result) : []
    //
    //   this.source = res;
    // },
    //
    // handleCurrentChange(val) {// 分页
    //   this.currentPage = val;
    //   this.parametricWork(12, this.currentPage);
    // },

    handleScroll() {// 滚动方法
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
    },

    // handleScrollTo(id) {//侧边导航锚点滚动
    //   const element = document.getElementById(id);
    //   if (!element) return;
    //   const navHeight = document.getElementById("navContent");
    //   const offset = navHeight ? navHeight.offsetHeight : 0;
    //   const top = element.getBoundingClientRect().top + window.pageYOffset - offset - 100;
    //   window.scroll({ top, behavior: "smooth" });
    //   this.navActive = id;
    // },

    changeLanguage(lang) {//语言栏切换
      this.sidebar = lang;
      this.$loadLanguageAsync(lang);
    },

    // handelTab(tabIndex) {//rules tab
    //   this.tab = tabIndex;
    // },
  },
};
